/**
 * `/ban-do` — **BẢN ĐỒ TUYẾN** (TK-44 §4, lee 24/10): bản đồ lớn của Vận hành, CHỈ XEM.
 *   · Vào từ nút ⤢ trên thẻ bản đồ Vận hành (`?tuyen=&tu=`), từ menu "Bản đồ tuyến", từ tab Đèn của trang tủ (`?tu=`).
 *   · Nền TỐI như Vận hành; chỉ vẽ đèn THUỘC HỆ THỐNG (máy chủ lọc); bấm chấm đèn ⇒ ô đèn như Vận hành (dim theo luật nhận lệnh).
 *   · KHÔNG còn chế độ sửa (`?sua=1` bỏ) — xếp vị trí đèn là việc của Cài đặt ban đầu (`/cai-dat-ban-dau?tu=&xep=1`).
 *   · Nút quay về Vận hành trả về `/?tuyen=&tu=` y như lúc đi.
 */
import { useEffect, useMemo, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { useAlarms, useTree } from '../lib/queries';
import { useNemaBat } from '../lib/nema';
import { tuSo1 } from '../lib/vanHanh';
import { BanDoTu, toaDoHopLe } from '../components/BanDoTu';
import { HopLopNema, LopDenNema, useLopNema } from '../components/nema/LopDenNema';
import { khoaDen } from '../components/vanhanh/BangDenTuyen';
import { ODenChon } from '../components/vanhanh/ODenChon';
import { ErrorBox, Spinner } from '../components/ui';

export default function BanDoPage() {
  const tree = useTree();
  const alarms = useAlarms();
  const nema = useNemaBat();
  const [sp] = useSearchParams();
  useEffect(() => { document.title = 'Bản đồ tuyến — SDKD Chiếu sáng'; }, []);
  const coNema = nema.trangThai === 'bat';
  const tuUrl = sp.get('tu'), tuyenUrl = sp.get('tuyen');
  /* tuyến: tham số, không có thì tuyến của tủ đang chọn; lớp đèn chỉ của tuyến ấy (không có ⇒ mọi tuyến) */
  const tuyenId = tuyenUrl ?? (tuUrl ? (tree.data ?? []).find((r) => r.cabinets.some((c) => c.id === tuUrl))?.id ?? null : null);
  const tuyenIds = coNema ? (tuyenId ? [tuyenId] : (tree.data ?? []).map((r) => r.id)) : [];
  const lop = useLopNema(tuyenIds);
  const r = tuyenId ? (tree.data ?? []).find((x) => x.id === tuyenId) ?? null : null;
  /* tủ đang chọn ⇒ bay tới tủ ấy; chỉ tuyến ⇒ bay tới tủ số 1 của tuyến (cùng luật Vận hành) */
  const tu1 = useMemo(() => (r && !tuUrl ? tuSo1(r.cabinets.filter((c) => toaDoHopLe(c.lat, c.lng))) : null), [r, tuUrl]);
  const diemKhung = useMemo<[number, number][] | null>(() => (tu1 ? [[tu1.lat as number, tu1.lng as number]] : null), [tu1]);
  const [lanKhop, setLanKhop] = useState(0);
  useEffect(() => { if (tu1) setLanKhop((n) => n + 1); }, [tu1?.id]);
  const [lanChon, setLanChon] = useState(0);
  useEffect(() => { setLanChon((n) => n + 1); }, [tuUrl]);
  const [denChon, setDenChon] = useState<string | null>(null);
  const denDangChon = denChon ? lop.den.find((d) => khoaDen(d) === denChon) ?? null : null;
  /* quay về Vận hành mang đúng tham số lúc đi */
  const ve = new URLSearchParams({ ...(tuyenUrl ? { tuyen: tuyenUrl } : {}), ...(tuUrl ? { tu: tuUrl } : {}) }).toString();
  return (
    <div className="space-y-3" data-o="ban-do-tuyen">
      <div className="flex flex-wrap items-center gap-3">
        <h1 className="chu-tieude m-0 text-[20px] font-semibold leading-tight text-chu-1">Bản đồ tuyến</h1>
        {r && <span className="min-w-0 truncate text-sm text-chu-2" data-o="ten-tuyen">{r.tenDayDu}</span>}
        <Link to={`/${ve ? `?${ve}` : ''}`} className="ml-auto text-sm text-nhan hover:underline" data-o="ve-van-hanh">← Về Vận hành</Link>
      </div>
      {tree.isLoading && <Spinner label="Đang tải danh sách tủ…" />}
      {tree.isError && <ErrorBox xam error={tree.error} onRetry={() => void tree.refetch()} />}
      <div className="relative">
        <BanDoTu cay={tree.data} canhBao={alarms.data} caoLop="h-[calc(100dvh-13rem)] min-h-[320px]" toanManHinh nenToi
          diemKhung={diemKhung} lanKhop={lanKhop} tuChon={tuUrl} lanChon={lanChon}
          lopThem={coNema ? <LopDenNema st={lop} tuChon={null} noiBat={denChon} onChonDen={setDenChon} bayNoiBat={false} /> : undefined}
          hopTrai={coNema ? <HopLopNema st={lop} cheDo="ban-do" /> : undefined} />
        {denDangChon && (
          <div className="absolute inset-x-2 bottom-2 z-[600] md:inset-x-auto md:bottom-auto md:right-3.5 md:top-[62px] md:w-[330px]" data-o="o-noi-den">
            <ODenChon d={denDangChon} onDong={() => setDenChon(null)} />
          </div>
        )}
      </div>
    </div>
  );
}
